import React, { useState, useEffect, useRef, useContext } from 'react'
//***********************Componentes PrimeReact****************************** */
import { Toast } from 'primereact/toast';

//***********************Componentes Generales****************************** */
import Card from '../../../../../Base/Components/Card/Card';
import Loader from '../../../../../Base/Components/Loader/Loader';
import AgGrid from '../../../../../Base/Components/Tables/AgGrid/AgGrid';
import CalendarioOperativo from '../../../../../Base/Components/CalendarioOperativo/CalendarioOperativo';

//**************************Consultas API*************************************** */

import { getEncabezadosIngresosQuimicosFechas } from '../../../../../API/Inventario/InventarioQuimicosyColorantes/IngresosQCRequest'
import { AuthContext } from '../../../../../Base/Context/AuthContext/AuthContext';
import ModalCuentasPorPagarCompras from '../../../../../Base/Screens/Proveedores/CuentasPorPagar/ModalCXP/ModalCuentasPorPagarCompras';
import { Tag } from 'primereact/tag';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Checkbox } from 'primereact/checkbox';
import { getDateTimeStringSQL, getDateTimeStringSQL24 } from '../../../../../Base/Services/Moment/Luxon';
import { toastShow } from '../../../../../Base/Services/ToastService';
import { postEstadoFinazasRegistros } from '../../../../../Base/API/CuentasPorPagar/CXP/CuentasPorPagarRequest';
import { getDateProduction } from '../../../../../Base/Services/FechasService';

const IngresosQuimicosyColorantesEnc = () => {
    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState([]);
    const [dates, setDates] = useState([new Date(), new Date()]);
    const [dialogFactura, setDialogFactura] = useState(false);
    const [IdFactura, setIdFactura] = useState(null)

    const { userAuth } = useContext(AuthContext);

    const DiasVencidos = (DiasVencidos) => {
        if (DiasVencidos < 0) {
            return (
                <span style={{ color: 'green', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex'>{DiasVencidos}</span>
            )
        } else {
            return (
                <span style={{ color: 'red', justifyContent: 'center', fontWeight: 'bold' }}
                    className='text-overFlow text-alingth-center d-flex' >{DiasVencidos}</span>
            )
        }
    }

    const obtenerInformacion = async () => {
        setLoading(true)
        const result = await getEncabezadosIngresosQuimicosFechas(getDateProduction(dates));
        setData(result)
        setSelected([])
        setLoading(false)
    }

    const EstadoTemplate = (rowData) => {
        switch (rowData.IdEstadoFinanzas) {
            case 3581:
                return <Tag style={{ width: 100, backgroundColor: "rgb(0, 191, 57)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3607:
                return <Tag style={{ width: 100, backgroundColor: "rgb(217, 206, 41)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3580:
                return <Tag style={{ width: 100, backgroundColor: "rgb(227, 63, 63)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3713:
                return <Tag style={{ width: 100, backgroundColor: "rgb(63, 142, 227)" }} value={rowData.EstadoFinanzas} />
                break;
            case 3714:
                return <Tag style={{ width: 100, backgroundColor: 'rgba(125, 129, 126, 0.75)' }} value={rowData.EstadoFinanzas} />
                break;

            default:
                return <div><span>{rowData.EstadoFinanzas}</span></div>
                break;
        }
    }

    const hideDialog = () => {
        setDialogFactura(false)
        setIdFactura(null)
    }

    const RecibirFactura = async () => {
        setLoading(true)
        if (selected.length > 0) {
            let registroManuales = selected.filter((s) => [3713,3580,3714].includes(s?.IdEstadoFinanzas) === true)
            let datosEnviar = registroManuales?.map((r) => {
                return {
                    Id: r?.Id,
                    IdEstadoFinanzas: r?.IdEstadoFinanzas === 3580 ? 3713 : 3580,
                    IdUserEditCompras: userAuth.idUser,
                    FechaEdit: getDateTimeStringSQL24(new Date()),
                    IdIngresoReferencia: r.Id,
                    IdReferencia: 7,
                    IsRegistroManual: 0,
                    FechaRecibidoCompras: r?.IdEstadoFinanzas === 3714 ? getDateTimeStringSQL24(new Date()) : null

                }
            });
            if (datosEnviar.length > 0) {
                const result = await postEstadoFinazasRegistros(datosEnviar)
                if (result) {
                    if (result[0].ERROR === 0) {
                        toastShow(toast, 'success', result[0]?.MSJ)
                        obtenerInformacion()
                    }
                    else {
                        toastShow(toast, 'error', result[0]?.MSJ)
                    }
                }
            }

            setSelected([])
            setLoading(false)
        }
    }

 const RevisadoBodega = async () => {
        setLoading(true)
        if (selected.length > 0) {
            let registroValidos = selected.filter((s) => [3580,3714].includes(s?.IdEstadoFinanzas) === true)
            let datosEnviar = registroValidos?.map((r) => {
                return {
                    Id: r?.Id,
                    IdEstadoFinanzas: r?.IdEstadoFinanzas === 3580 ? 3714 : 3580,
                    IdUserEditCompras: userAuth.idUser,
                    FechaEdit: getDateTimeStringSQL(new Date()),
                    IdIngresoReferencia: r.Id,
                    IdReferencia: r.IdReferencia,
                    IsRegistroManual: 0,
                    FechaRevisadoBodega: r?.IdEstadoFinanzas === 3580 ? getDateTimeStringSQL(new Date()) : null,
                    FechaRecibidoCompras: null
                }
            });

            if (datosEnviar?.length > 0) {
                const result = await postEstadoFinazasRegistros(datosEnviar)
                if (result) {
                    if (result[0]?.ERROR === 0) {
                        toastShow(toast, 'success', result[0]?.MSJ)
                        obtenerInformacion()
                    }
                    else {
                        toastShow(toast, 'error', result[0]?.MSJ)
                    }
                }
            }
            setLoading(false)
            setSelected([])
        }
    }

    const table = {
        Data: data,
        selected: selected,
        setSelected: setSelected,
        Columns: [
            {
                field: 'Id',
                header: 'Id',
                headerEn: 'Id',
                className: 'small',
                width: 60,
                hidden: userAuth.IdRol === 1
            },
            {
                field: 'IncomeDate',
                header: 'Fecha Ingreso',
                headerEn: 'Income Date',
                className: 'small',
                Format: 'Date',
                frozen: true,
            },
            {
                field: 'NoIngreso',
                header: 'No Ingreso',
                headerEn: 'No. Income',
                className: 'small',
                Format: 'Center',
                onCellDoubleClicked: ({ data }) => {
                    if (data?.Id > 0) {
                        setIdFactura(data?.Id)
                        setDialogFactura(true)
                    }
                },
                Sumary: 'count',
                frozen: true,
            },
            {
                field: 'EstadoFinanzas',
                header: 'Estado Finanzas',
                headerEn: 'Finance Status',
                className: 'small',
                // Format: 'Template',
                // body: (rowData) => EstadoTemplate(rowData),
                Format: 'Estado',
                body: (rowData) => ({
                    ID: rowData?.IdEstadoFinanzas,
                    Estado: rowData?.EstadoFinanzas
                }),
                
            },
            {
                field: 'FechaDocumento',
                header: 'Fecha Factura',
                headerEn: 'Invoice Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'Documento',
                header: 'Factura',
                headerEn: 'Invoice',
                className: 'medium',
                onCellDoubleClicked: ({ data }) => {
                    if (data.Id > 0) {
                        setIdFactura(data?.Id)
                        setDialogFactura(true)
                    }
                }
            },
            {
                field: 'CustomerName',
                header: 'Proveedor',
                headerEn: 'Supplier',
                className: 'Xlarge',
            },
            // {
            //     field: 'OCE',
            //     header: 'OCE',
            //     headerEn: 'OCE',
            //     className: 'small',
            //     Format: 'Center'
            // },
            {
                field: 'PurchaseOrder',
                header: 'Orden Compra',
                headerEn: 'Purchase Order',
                className: 'small',
                Format: 'Center',
                onCellDoubleClicked: ({ data }) => {
                    if (data.PurchaseOrder) {
                    }
                }
            },
            {
                field: 'NoCAI',
                header: 'CAI',
                headerEn: 'CAI',
                className: 'large',
            },
            {
                field: 'TermName',
                header: 'Terminos',
                headerEn: 'Terms',
                className: 'small',
                Format: 'Center'
            },
            {
                field: 'FechaVencido',
                header: 'Fecha Vencido',
                headerEn: 'Expired Date',
                className: 'small',
                Format: 'Date',
            },
            {
                field: 'DiasVencidos',
                header: 'Dias Vencidos',
                headerEn: 'Expired Days',
                className: 'Xsmall',
                Format: 'Template',
                body: rowData => DiasVencidos(rowData.DiasVencidos)
            },
            {
                field: 'Id',
                header: 'Recibido ',
                headerEn: 'Recibido',
                className: 'Xsmall',
                Format: 'Template',
                frozen: true,
                alignFrozen: 'right',
                body: (data) => data.Id ? (
                    <div onClick={() => { if (selected.length === 0) setSelected([data]) }}
                        onDoubleClick={() => { if ([3713, 3580, 3714].includes(data?.IdEstadoFinanzas)) RecibirFactura() }} className='d-flex flex-row' style={{ justifyContent: 'center' }}>
                        <Checkbox checked={[3581, 3607, 3713].includes(data?.IdEstadoFinanzas)} disabled={[3581, 3607].includes(data?.IdEstadoFinanzas)} />
                    </div>
                ) : null,
            },
            // {
            //     field: 'Id',
            //     header: 'Revisado Bodega ',
            //     headerEn: 'Revisado Bodega',
            //     className: 'Xsmall',
            //     Format: 'Template',
            //     frozen: true,
            //     alignFrozen: 'right',
            //     body: (data) => data.Id ? (
            //         <div onClick={() => { if (selected.length === 0) setSelected([data]) }}
            //             onDoubleClick={() => { if ([3580,3714].includes(data?.IdEstadoFinanzas)) RevisadoBodega() }} className='d-flex flex-row' style={{ justifyContent: 'center' }}>
            //             <Checkbox checked={[3581, 3607, 3713, 3714].includes(data?.IdEstadoFinanzas)} disabled={[3581, 3607, 3713].includes(data?.IdEstadoFinanzas)} />
            //         </div>
            //     ) : null,
            // },

            {
                field: 'MontoL',
                header: 'Monto L',
                headerEn: 'Amount L',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                Frozen: true,
                alignFrozen: 'right'
            },
            {
                field: 'MontoD',
                header: 'Monto $',
                headerEn: 'Amount $',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum',
                Frozen: true,
                alignFrozen: 'right',

            },
        ]
    }


    return (
        <div>
            <Loader loading={loading} querySelector={'#IngresosQuimicos'} />
            <Toast ref={toast} />
            <ConfirmDialog />
            <Card
                titulo={
                    <div >
                        <CalendarioOperativo
                            getInfo={getEncabezadosIngresosQuimicosFechas}
                            data={data}
                            setData={setData}
                            Nombre={'Ingresos Quimicos'}
                            selected={selected}
                            setSelected={setSelected}
                            dates={dates}
                            setDates={setDates}
                            type='Month'
                            loading={loading}
                            setLoading={setLoading}
                        />
                    </div>
                }
                contenido={<div className='pt-4' style={{ height: '85vh' }} id='IngresosQuimicos'>
                    <AgGrid table={table} />
                </div>}
            />
            <ModalCuentasPorPagarCompras
                dialogCuentas={dialogFactura}
                hideDialog={hideDialog}
                IdFactura={IdFactura}
            />
        </div>
    )
}

export default IngresosQuimicosyColorantesEnc
